import type { ReactNode } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@mlm/ui';
import { useIsSuperAdmin } from '../lib/auth-store';

/**
 * Hard super-admin route guard — for platform-tier pages that even tenant
 * admins must not see (e.g. Layout & Theme). Unlike `RequirePerm` (which any
 * granted role can pass), this gates on the ROLE, so it can't be opened up by
 * granting a permission.
 */
export function RequireSuperAdmin({
  label,
  children,
}: {
  /** Friendly label for the "no access" message. */
  label: string;
  children: ReactNode;
}) {
  const allowed = useIsSuperAdmin();
  if (allowed) return <>{children}</>;
  return (
    <Card>
      <CardHeader>
        <CardTitle>No access</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">
          The <strong>{label}</strong> page is restricted to super-admins.
        </p>
      </CardContent>
    </Card>
  );
}
